import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../Pages/Login";
import Dashboard from "../Layout/Dashboard";
import ProtectedRoute from "./ProtectRoutes";
import EmailTemplates from "../Pages/EmailTemplates";
import Logs from "../Pages/Logs";
import Alluser from "../Pages/Alluser";
import Mainpage from "../Pages/Mainpage";
import Binancecopy from "../Pages/Binancecopy";
import Activeusercopy from "../Pages/Activeusercopy";
import AllApi from "../Pages/AllApi";
import BotTransaction from "../Pages/BotTransaction";
// import BotTransaction from "../Pages/BotListTransaction";
import AllBots from "../Pages/AllBots";
import SupportAdmin from "../Pages/SupportAdmin";
import LogsTrans from "../Pages/LogsTrans";
import Position from "../Pages/Position";
import AllTrades from '../Pages/AllTrades'
import MainSetting from "../Pages/Settings/MainSetting";


const Routerpage = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute Component={Dashboard}/>}> 
            {/* <Route index element={<ProtectedRoute Component={Addfund}/>} /> */}
            <Route index element={<ProtectedRoute Component={Mainpage}/>} />
            <Route path="/dashboard/emailTemplates" element={<ProtectedRoute Component={EmailTemplates}/>} />
            <Route path="/dashboard/botlist" element={<ProtectedRoute Component={BotTransaction}/>} />
            <Route path="/dashboard/alluser" element={<ProtectedRoute Component={Alluser}/>} />
            <Route path="/dashboard/livedata" element={<ProtectedRoute Component={Binancecopy}/>} />
            <Route path="/dashboard/activeuser" element={<ProtectedRoute Component={Activeusercopy}/>} />
            <Route path="/dashboard/mainpage" element={<ProtectedRoute Component={Mainpage}/>} />
            {/* <Route path="/dashboard/image" element={<ProtectedRoute Component={Image}/>} /> */}
            <Route path="/dashboard/allApi" element={<ProtectedRoute Component={AllApi}/>} />
            <Route path="/dashboard/allbots" element={<ProtectedRoute Component={AllBots}/>} />

            <Route path="/dashboard/alltrades" element={<ProtectedRoute Component={AllTrades}/>} />

            <Route path="/dashboard/support" element={<ProtectedRoute Component={SupportAdmin}/>} />
            <Route path="/dashboard/errors" element={<ProtectedRoute Component={LogsTrans}/>} />
            <Route path="/dashboard/position" element={<ProtectedRoute Component={Position}/>} />

            <Route path="/dashboard/setting" element={<ProtectedRoute Component={MainSetting}/>} />
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default Routerpage;
